module.exports = __webpack_public_path__ + "static/media/logo-color.7db79325.svg";